import { useTranslation } from '@/utils/hook'
import { RiArrowRightLine } from '@remixicon/react'
import { HomeHeading, HomeLink } from './presentation'
import styles from './home.module.css'

const usageItems = [
  {
    titleKey: 'home.usageCreators',
    links: [
      {
        href: 'https://heyform.net/templates/customer-contact-form-template',
        textKey: 'home.usageCreators1'
      },
      {
        href: 'https://heyform.net/templates/customer-feedback-survey-template',
        textKey: 'home.usageCreators2'
      },
      {
        href: 'https://heyform.net/templates/workshop-registration-form-template',
        textKey: 'home.usageCreators3'
      }
    ]
  },
  {
    titleKey: 'home.usageProduct',
    links: [
      {
        href: 'https://heyform.net/templates/product-feedback-survey-template',
        textKey: 'home.usageProduct1'
      },
      {
        href: 'https://heyform.net/templates/product-registration-form-template',
        textKey: 'home.usageProduct2'
      },
      {
        href: 'https://heyform.net/templates/product-order-form-template',
        textKey: 'home.usageProduct3'
      }
    ]
  },
  {
    titleKey: 'home.usageMarketing',
    links: [
      {
        href: 'https://heyform.net/templates/free-trial-form-template',
        textKey: 'home.usageMarketing1'
      },
      {
        href: 'https://heyform.net/templates/lead-capture-form-template',
        textKey: 'home.usageMarketing2'
      },
      {
        href: 'https://heyform.net/templates/referral-form-template',
        textKey: 'home.usageMarketing3'
      }
    ]
  },
  {
    titleKey: 'home.usageHR',
    links: [
      {
        href: 'https://heyform.net/templates/exit-interview-form-template',
        textKey: 'home.usageHR1'
      },
      {
        href: 'https://heyform.net/templates/job-application-form-template',
        textKey: 'home.usageHR2'
      },
      {
        href: 'https://heyform.net/templates/employee-satisfaction-survey-template',
        textKey: 'home.usageHR3'
      }
    ]
  },
  {
    titleKey: 'home.usageSupport',
    links: [
      {
        href: 'https://heyform.net/templates/client-satisfaction-survey-template',
        textKey: 'home.usageSupport1'
      },
      {
        href: 'https://heyform.net/templates/brand-survey-form-template',
        textKey: 'home.usageSupport2'
      },
      {
        href: 'https://heyform.net/templates/customer-testimonials-template',
        textKey: 'home.usageSupport3'
      }
    ]
  },
  {
    titleKey: 'home.usageEducation',
    links: [
      {
        href: 'https://heyform.net/templates/student-enrollment-form-template',
        textKey: 'home.usageEducation1'
      },
      {
        href: 'https://heyform.net/templates/teacher-feedback-form',
        textKey: 'home.usageEducation2'
      },
      {
        href: 'https://heyform.net/templates/student-survey-template',
        textKey: 'home.usageEducation3'
      }
    ]
  }
]

function UsageItem({ titleKey, links }) {
  const t = useTranslation()
  return (
    <div className={styles.template}>
      <h3>{t(titleKey)}</h3>
      <ul>
        {links.map(link => (
          <li key={link.href}>
            <a href={link.href}>
              {t(link.textKey)}
              <RiArrowRightLine aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function Usage() {
  const t = useTranslation()
  return (
    <section
      className={`${styles.section} ${styles.soft}`}
      aria-labelledby="home-templates-title"
    >
      <div className={styles.container}>
        <HomeHeading id="home-templates-title" title={t('home.usageTitle')}>
          {t('home.usageDesc')}
        </HomeHeading>
        <div className={styles.templates}>
          {usageItems.map(item => (
            <UsageItem key={item.titleKey} {...item} />
          ))}
        </div>
        <div className={styles.afterGrid}>
          <HomeLink href="/templates">{t('home.usageCTA')}</HomeLink>
        </div>
      </div>
    </section>
  )
}
